import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Box,
    IconButton,
    Paper,
    Tooltip,
    Grid,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
    Breadcrumbs,
    Link,
    TextField
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import axiosInstance from '../../lib/axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import RoomSelection from '../RoomSelection/RoomSelection';
import { first } from 'lodash';
import { ToastContainer } from 'react-toastify';

const RoomChange = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const contentRef = useRef(null);
    const [OpenHistoryTable, setOpenHistoryTable] = useState(false);
    const [selectedDates, setSelectedDates] = useState({
        from: null,
        to: null
    });
    const [selectedBedCatId, setSelectedBedCatId] = useState(null);
    const [selectedPropId, setSelectedPropId] = useState(null);
    const [oldBedId, setOldBedId] = useState('')
    const [oldRent, setOldRent] = useState('')
    const { BookId } = location.state || {};
      const [isRoomSelected, setIsRoomSelected] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => {
        if (BookId) {
            fetchRoomChangeData();
        }
    }, [BookId]);

    const isCurrentOrFutureMonth = (row) => {
        const currentDate = moment();
        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        const monthNumber = monthNames?.indexOf(row?.MonthNm) + 1;

        const rowDate = moment(`${row?.YearNm}-${monthNumber?.toString().padStart(2, '0')}-01`, 'YYYY-MM-DD');

        return rowDate.isSameOrAfter(currentDate, 'month');
    };

    const fetchRoomChangeData = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.post(
                `BedCalendar/GetTrnBookingDtlwise`,
                {
                    Flag: "",
                    BookId: BookId
                }
            );

            if (response.data.Status === 0) {
                const formattedData = response.data.Data.map(obj => ({
                    ...obj,
                    PyadDt: moment(obj.PyadDt).format("MM-DD-YYYY"),
                    Adjustment: 0,
                    Remark: "",
                    BookDtlId: obj.BookDtlId,
                    RoomBedId: obj.RoomBedId,
                    StdRent: obj.StdRent
                }));
                setData(formattedData);
                if (response.data.Data.length > 0) {
                    const firstItem = response.data.Data[0];
                    console.log('firstItem',firstItem)
                    setSelectedDates({
                        from: moment(firstItem.BookDtFrom),
                        to: moment(firstItem.CheckoutDt)
                    });
                    setOldRent(firstItem.StdRent)
                    setOldBedId(firstItem.RoomBedId)
                    setSelectedBedCatId(firstItem.BedCatId);
                    setSelectedPropId(firstItem.PropId);
                }
            } else {
                toast.error(response.data.Message || 'Error fetching room change data');
            }
        } catch (error) {
            console.error('Error fetching room change data:', error);
            toast.error('Failed to fetch room change data');
        } finally {
            setIsLoading(false);
        }
    };

    const columns = [
        { id: 'MonthNm', label: 'Month', minWidth: 80 },
        { id: 'YearNm', label: 'Year', minWidth: 40 },
        { id: 'StdRent', label: 'StdRent', minWidth: 60 },
        { id: 'ExtraRent', label: 'ExtraRent', minWidth: 60 },
        { id: 'FmDisc', label: 'FmDisc', minWidth: 60 },
        { id: 'NetRent', label: 'NetRent', minWidth: 60 },
        { id: 'CouponDisc', label: 'CouponDisc', minWidth: 60 },
        { id: 'EffRent', label: 'EffRent', minWidth: 60 },
        { id: 'PyadAmt', label: 'PyadAmt', minWidth: 60 },
        { id: 'BalPyadAmt', label: 'BalPyadAmt', minWidth: 60 },
        { id: 'Adjustment', label: 'Adjustment', minWidth: 80 },
        { id: 'RoombedName', label: 'Bed/Room', minWidth: 70 },
        { id: 'PyadDt', label: 'PyDate', minWidth: 60 },
        { id: 'Remark', label: 'Remark', minWidth: 100 }
    ];


    const handleAdjustmentChange = (index, value) => {
        const newData = [...data];
        if (isCurrentOrFutureMonth(newData[index])) {
            newData[index].Adjustment = value;
            setData(newData);
        } else {
            toast.warning('You can only adjust values for current and future months');
        }
    };

    const handleRemarkChange = (index, value) => {
        const newData = [...data];
        if (isCurrentOrFutureMonth(newData[index])) {
            newData[index].Remark = value;
            setData(newData);
        } else {
            toast.warning('You can only add remarks for current and future months');
        }
    };
    const handleRowDoubleClick = async (newRoom) => {
    try {
        setIsLoading(true);
        const currentRoom = data.length > 0 ? data[0] : null;

        if (!currentRoom) {
            toast.error("No current room found");
            return;
        }
        
        const response = await axiosInstance.post('BedCalendar/GetPropWiseBedCalendarMonthRoomBed', {
            RoomBedId: newRoom.RoomBedId,
            PropId: selectedPropId,
            BookDtFrom: moment().format('YYYY-MM-DD'),
            CheckoutDt: selectedDates.to?.format('YYYY-MM-DD'),
            Flag: "",
            BedCatId: newRoom.BedCatId,
            OldRoomBedId: oldBedId,
            BookId: BookId
        });

        if (response.data.Status === 1) {
            const updatedData = data.map(item => {
                if (isCurrentOrFutureMonth(item)) {
                    return {
                        ...item,
                        RoombedName: newRoom.RoombedName,
                        RoomTypeName: newRoom.RoomTypeName,
                        RoomBedTypeName: newRoom.RoomBedTypeName,
                        RoomViewNAme: newRoom.RoomViewNAme,
                        WingName: newRoom.WingName,
                        FloorName: newRoom.FloorName,
                        BedRent: newRoom.BedRent,
                        RoomBedId: newRoom.RoomBedId,
                        RoomTypeId: newRoom.RoomTypeId,
                        RoomBedTypeId: newRoom.RoomBedTypeId,
                        RoomViewId: newRoom.RoomViewId,
                        BedCatId: newRoom.BedCatId,
                        RoomId: newRoom.RoomId,
                    };
                }
                return item;
            });
            
            console.log(updatedData, 'updatedData');
            setData(updatedData);
            setOpenHistoryTable(false);
              setIsRoomSelected(true);
                setIsSubmitted(false);
        } else {
            toast.error(response.data.Message || "Failed to change room");
        }
    } catch (error) {
        console.error("Room change error:", error);
        toast.error("Error changing room");
    } finally {
        setIsLoading(false);
    }
};

    const handleBackClick = () => {
        navigate(-1);
    };
    const handleCancel=()=>{
        navigate('/enquiry/checkintable')
    }

    const handleHomeClick = () => {
        navigate('/dashboard');
    };

    const handleLocationClick = () => {
        navigate('/enquiry/pre-registration');
    };

    const handleClickCheckAvaCal = () => {
        if (data.length > 0) {
            setOpenHistoryTable(true);
        } else {
            toast.warning('No booking data available');
        }
    };

    const handleCloseRoom = () => {
        setOpenHistoryTable(false)
    }

    const handleSubmitdata = async () => {
        try {
            setIsLoading(true);
            const currentRoom = data.length > 0 && data[0];
            console.log('data', currentRoom)
            if (!currentRoom) {
                toast.error("No room data available");
                return;
            }

            const originalRoomBedId = currentRoom.RoomBedId;
            const originalBedRent = currentRoom.BedRent;

            if (!originalRoomBedId) {
                toast.error("Unable to determine original room information");
                return;
            }

            const monthNames = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];

            const payload = data.map(item => {
                const monthId = monthNames.indexOf(item.MonthNm) + 1;

                return {
                    BookId: BookId,
                    BookDtlId: item.BookDtlId,
                    RoomBedId: item.RoomBedId,
                    OldRoomBedId: oldBedId,
                    AdjAmt: parseFloat(item.Adjustment),
                    Remark: item.Remark,
                    MonthId: monthId,
                    MonthNm: item.MonthNm,
                    YearNm: item.YearNm,
                    BedRent: parseFloat(item.BedRent) || 0,
                    OldBedRent: oldRent,
                    CreatedBy: 1,
                    Flag: ""
                };
            });
            const response = await axiosInstance.post(
                'TrnBooking/TrnBookingdtlRoomBedChange',
                payload
            );

            if (response.data.Status === 0) {
                toast.success(response.data.Message );
                fetchRoomChangeData();
                 setIsSubmitted(true);
                setIsRoomSelected(false);
            } else {
                toast.error(response.data.Message || "Failed to submit room change");
            }
        } catch (error) {
            console.error("Submit error:", error);
            if (error.response) {
                console.error("Response data:", error.response.data);
                console.error("Response status:", error.response.status);
            }
            toast.error("Error submitting room change");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', p: 2 }}>
              <ToastContainer />
            <Box ref={contentRef} sx={{ flex: 1 }}>
                {/* Header Section */}
                <Paper elevation={3} sx={{ p: 1.5, mb: 2 }}>
                    <Grid container alignItems="center" spacing={2}>
                      
                            <Grid item>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    component="button"
                                    variant="body2"
                                    onClick={handleHomeClick}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        textDecoration: 'none',
                                        color: '#635bff',
                                        '&:hover': { textDecoration: 'underline' }
                                    }}
                                >
                                    <HomeIcon sx={{ mr: 0.5, fontSize: 16 }} />
                                    Home
                                </Link>
                                <Link
                                    component="button"
                                    variant="body2"
                                    onClick={handleLocationClick}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        textDecoration: 'none',
                                        color: '#635bff',
                                        '&:hover': { textDecoration: 'underline' }
                                    }}
                                >
                                    <LocationOnIcon sx={{ mr: 0.5, fontSize: 16 }} />
                                    Pre-registration
                                </Link>
                                <Typography color="text.primary" variant="body2">
                                    Room Change
                                </Typography>
                            </Breadcrumbs>
                        </Grid>
                          <Grid item>
                            <Tooltip title="Back to the Previous Page" placement="top">
                                <IconButton
                                    onClick={handleBackClick}
                                    sx={{
                                        backgroundColor: '#635bff',
                                        borderRadius: '50%',
                                        width: 35,
                                        height: 35,
                                        '&:hover': {
                                            backgroundColor: '#5a52e8',
                                        },
                                        boxShadow: 3,
                                    }}
                                >
                                    <ArrowBackIcon sx={{ color: 'white' }} />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item xs>
                            <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', color: '#333' }}>
                                Room Change
                            </Typography>
                        </Grid>

                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{
                                    backgroundColor: '#635bff',
                                    '&:hover': {
                                        backgroundColor: '#5a52e8',
                                    },
                                    mr: 2,
                                    padding: '4px 12px',
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    boxShadow: 2,
                                }}
                                onClick={handleClickCheckAvaCal}
                            >
                                Room Availability
                            </Button>
                        </Grid>

                    
                    </Grid>
                </Paper>

                <Paper elevation={3} sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    {isLoading ? (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '400px'
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    ) : (
                        <TableContainer sx={{ flex: 1 }}>
                            <Table stickyHeader aria-label="room change table" sx={{ borderCollapse: 'collapse' }}>
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                style={{
                                                    minWidth: column.minWidth,
                                                    backgroundColor: '#f5f5f5',
                                                    fontWeight: 'bold',
                                                    borderBottom: '2px solid #e0e0e0',
                                                    padding: 0,
                                                    margin: 2,
                                                    border: '1px solid #e0e0e0',
                                                }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((row, index) => {
                                        const isEditable = isCurrentOrFutureMonth(row);
                                        return (
                                            <TableRow
                                                hover
                                                key={index}
                                                sx={{
                                                    cursor: isEditable ? 'pointer' : 'default',
                                                    '&:hover': {
                                                        backgroundColor: isEditable ? '#f8f9fa' : 'inherit',
                                                    },
                                                    '&:nth-of-type(even)': {
                                                        backgroundColor: '#fafafa',
                                                    },
                                                    opacity: isEditable ? 1 : 0.7
                                                }}
                                                // onDoubleClick={() => isEditable && handleClickCheckAvaCal(index)}
                                            >
                                                {columns.map((column) => {
                                                    if (column.id === 'Adjustment') {
                                                        return (
                                                            <TableCell
                                                                key={column.id}
                                                                sx={{
                                                                    padding: .5,
                                                                    margin: 0,
                                                                    border: '1px solid #e0e0e0'
                                                                }}
                                                            >
                                                                <TextField
                                                                    type="number"
                                                                    value={row.Adjustment}
                                                                    onChange={(e) => handleAdjustmentChange(index, e.target.value)}
                                                                    disabled={!isEditable}
                                                                    size="small"
                                                                    inputProps={{
                                                                        style: {
                                                                            padding: '4px',
                                                                            width: '60px'
                                                                        }
                                                                    }}
                                                                />
                                                            </TableCell>
                                                        );
                                                    } else if (column.id === 'Remark') {
                                                        return (
                                                            <TableCell
                                                                key={column.id}
                                                                sx={{
                                                                    padding: .5,
                                                                    margin: 0,
                                                                    border: '1px solid #e0e0e0'
                                                                }}
                                                            >
                                                                <TextField
                                                                    value={row.Remark}
                                                                    onChange={(e) => handleRemarkChange(index, e.target.value)}
                                                                    disabled={!isEditable}
                                                                    size="small"
                                                                    inputProps={{
                                                                        style: {
                                                                            padding: '4px',
                                                                            width: '100px'
                                                                        }
                                                                    }}
                                                                />
                                                            </TableCell>
                                                        );
                                                    } else {
                                                        return (
                                                            <TableCell
                                                                key={column.id}
                                                                sx={{
                                                                    padding: .5,
                                                                    margin: 0,
                                                                    border: '1px solid #e0e0e0',
                                                                    color: !isEditable ? 'text.secondary' : 'inherit'
                                                                }}
                                                            >
                                                                {row[column.id] || '-'}
                                                            </TableCell>
                                                        );
                                                    }
                                                })}
                                            </TableRow>
                                        );
                                    })}
                                    {data.length === 0 && (
                                        <TableRow>
                                            <TableCell
                                                colSpan={columns.length}
                                                align="center"
                                                sx={{
                                                    py: 4,
                                                    padding: 0,
                                                    margin: 0,
                                                    border: '1px solid #e0e0e0'
                                                }}
                                            >
                                                <Typography variant="body1" color="text.secondary">
                                                    No data available
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Paper>
                <Paper sx={{ textAlign: 'right', marginTop: '10px', backgroundColor: 'transparent', boxShadow: 'none' }}>
                    <Button
                        variant="contained"
                        sx={{
                            padding: '6px 16px',
                            textTransform: 'none',
                            fontWeight: 'bold',
                            marginRight: '10px',
                            boxShadow: 2,
                            backgroundColor: '#635bff',
                            '&:hover': {
                                backgroundColor: '#5a52e8',
                            }
                        }}
                        disabled={!isRoomSelected || isSubmitted}
                        onClick={handleSubmitdata}
                    >
                        Submit
                    </Button>
                    <Button
                        variant="outlined"
                        color="error"
                        sx={{
                            padding: '4px 16px',
                            textTransform: 'none',
                            fontWeight: 'bold',
                            borderWidth: '2px',
                            color: '#d32f2f',
                            borderColor: '#d32f2f',
                            '&:hover': {
                                borderWidth: '2px',
                                backgroundColor: 'rgba(211, 47, 47, 0.04)'
                            }
                        }}
                        onClick={handleCancel}
                    >
                        Cancel
                    </Button>
                </Paper>
            </Box>
            <RoomSelection
                open={OpenHistoryTable}
                onClose={handleCloseRoom}
                propId={selectedPropId}
                // dateFrom={selectedDates.from?.format('YYYY-MM-DD')}
                dateFrom={moment().format('YYYY-MM-DD')}
                dateTo={selectedDates.to?.format('YYYY-MM-DD')}
                onRoomSelect={handleRowDoubleClick}
                BedCatId={selectedBedCatId}
            />
        </Box>
    );
};

export default RoomChange;